// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inte-border{margin:20px 15px}.inte-border .title{font-size:18px;color:#333;font-weight:700}.inte-border .integrat-text-color{color:#666;margin:15px 0}.inte-border .integrat .el-input{width:200px}.inte-border .integrat .el-form-item__label{font-size:14px;width:170px;text-align:left}.inte-border .integrat .el-form-item__error{left:170px}", ""]);
// Exports
module.exports = exports;
